import { FC, useEffect, useLayoutEffect } from "react";
import { NavLink, useLocation } from "react-router-dom";
import classNames from "classnames";

import { ReactComponent as Cross } from "../../../assets/vectors/icons/x.svg";
import { ReactComponent as Menu } from "../../../assets/vectors/icons/menu.svg";
import logo from "../../../assets/vectors/logo/applia_logo_white.svg";
import { routes } from "../../../config/routes/routes";
import { Sidebar } from "../Sidebar/Sidebar";
import { UiBreakpoints } from "../../../config/ui/breakpoints";
import { useBoolean } from "../../../hooks/useBoolean";
import { useLockBodyScroll } from "../../../hooks/useLockBodyScroll";
import { usePrevious } from "../../../hooks/usePrevious";
import { useWindowSize } from "../../../hooks/useWindowSize";

const Header: FC = () => {
	const [isNavOpen, { toggle, off }] = useBoolean(false);
	const { width } = useWindowSize(50);
	const { pathname } = useLocation();
	const previousWidth = usePrevious<number | undefined>(width);

	useLockBodyScroll(width < UiBreakpoints.lg && isNavOpen);

	useEffect(() => {
		off();
	}, [off, pathname]);

	useLayoutEffect(() => {
		if (!width || width === previousWidth) {
			return;
		}

		if (width > UiBreakpoints.lg) {
			off();
		}
	}, [isNavOpen, off, previousWidth, width]);

	return (
		<div
			className={classNames("fixed z-50 left-0 top-0 right-0 lg:hidden", {
				"h-[100svh]": isNavOpen,
			})}
		>
			<div className="flex flex-row items-center justify-between bg-[#00348a] px-6 py-3 h-20 border-b border-white/20 gap-6">
				<NavLink to="/" className="flex items-center">
					<img src={logo} className="w-28" alt="APPLiA logo" />
				</NavLink>
				<button
					onClick={toggle}
					aria-expanded={isNavOpen}
					aria-label={isNavOpen ? "Close menu" : "Open menu"}
					className="flex items-center text-white hover:text-white/70 active:text-white/80 transition-colors"
				>
					{isNavOpen ? <Cross /> : <Menu />}
				</button>
			</div>

			{isNavOpen ? (
				<div className="overflow-y-auto isolate no-bg-scrollbar grow max-h-[calc(100svh-5rem)] bg-[#00348a]">
					<Sidebar routes={routes} mobile />
				</div>
			) : null}
		</div>
	);
};

export { Header };
